/*
==========================================================
Diafemme Expert Onboarding
Version : 1.0
Module 1 : Initialization Engineconst expert = result.expert;
Author : UBS + OpenAI
==========================================================
*/

/* ======================================================
   CONFIGURATION
====================================================== */

const WEB_APP_URL =
"https://script.google.com/macros/s/AKfycbyu3iWPf-6hhecxLw-HRJFNR4X--4fGcUg9-bWs9IV1KZoiiuiYkSkOGWquSz-nJedV/exec";

/* ======================================================
   GLOBAL STATE
====================================================== */

const ExpertOnboarding = {

    currentStep: 1,

    totalSteps: 6,

    expert: null,

    onboarding: {},

    initialized: false

};

/* ======================================================
   APPLICATION START
====================================================== */

document.addEventListener("DOMContentLoaded", initializeApplication);

/* ======================================================
   INITIALIZE APPLICATION
====================================================== */

function initializeApplication(){

    console.log("Diafemme Expert Onboarding v1.0");

    registerEvents();

    initialiseProgress();

    initialiseAccordions();

    ExpertOnboarding.initialized = true;

}

/* ======================================================
   REGISTER EVENTS
====================================================== */

function registerEvents(){

    const verifyButton =
        document.getElementById("verifyExpert");

    if(verifyButton){

        verifyButton.addEventListener(
            "click",
            verifyEmail
        );

    }

}

/* ======================================================
   PROGRESS
====================================================== */

function initialiseProgress(){

    updateProgress(1);

}

function updateProgress(step){

    ExpertOnboarding.currentStep = step;

    const current =
        document.getElementById("currentStep");

    const fill =
        document.getElementById("progressFill");

    if(current){

        current.textContent = step;

    }

    if(fill){

        fill.style.width =
            ((step / ExpertOnboarding.totalSteps) * 100) + "%";

    }

}

/* ======================================================
   ACCORDIONS
====================================================== */

function initialiseAccordions(){

    document
        .querySelectorAll(".df-accordion")
        .forEach(section=>{

            const header =
                section.querySelector(".df-accordion-header");

            if(!header) return;

            header.addEventListener("click",()=>{

                toggleAccordion(section.id);

            });

        });

}

function toggleAccordion(id){

    const accordion =
        document.getElementById(id);

    if(!accordion) return;

    accordion.classList.toggle("active");

}

function openAccordion(id){

    document
        .querySelectorAll(".df-accordion")
        .forEach(a=>a.classList.remove("active"));

    const accordion =
        document.getElementById(id);

    if(accordion){

        accordion.classList.add("active");

    }

}

/* ======================================================
   MESSAGE AREA
====================================================== */

function showSuccess(message){

    const box =
        document.getElementById("verificationMessage");

    if(!box) return;

    box.style.color="#2F6F61";

    box.innerHTML=message;

}

function showError(message){

    const box =
        document.getElementById("verificationMessage");

    if(!box) return;

    box.style.color="#C62828";

    box.innerHTML=message;

}

function clearMessage(){

    const box =
        document.getElementById("verificationMessage");

    if(!box) return;

    box.innerHTML="";

}

/* ======================================================
   HELPERS
====================================================== */

function setDisplay(id,value){

    const el=document.getElementById(id);

    if(el){

        el.textContent=value || "--";

    }

}

function setInput(id,value){

    const el=document.getElementById(id);

    if(el){

        el.value=value || "";

    }

}

function showElement(id){

    const el=document.getElementById(id);

    if(el){

        el.style.display="block";

    }

}

function hideElement(id){

    const el=document.getElementById(id);

    if(el){

        el.style.display="none";

    }

}

function scrollToTop(){

    window.scrollTo({

        top:0,

        behavior:"smooth"

    });

}

/* ======================================================
   PLACEHOLDERS
   (Implemented in next modules)
====================================================== */

/* ======================================================
   MODULE 2A.1
   VERIFY EXPERT EMAIL
====================================================== */

async function verifyEmail(){

        clearMessage();

    const emailField =
        document.getElementById("expertEmail");

    if(!emailField){

        showError("Email field not found.");

        return;

    }

    const email =
        emailField.value.trim().toLowerCase();

    if(email===""){

        showError(
            "Please enter your registered email address."
        );

        emailField.focus();

        return;

    }

    const emailPattern =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if(!emailPattern.test(email)){

        showError(
            "Please enter a valid email address."
        );

        emailField.focus();

        return;

    }

    const verifyButton =
        document.getElementById("verifyExpert");

    if(verifyButton){

        verifyButton.disabled = true;

        verifyButton.innerHTML =
            "Verifying...";

    }

    try{

       const result = await fetchExpert(email);
       
        showSuccess(
            "✔ Verification successful."
        );

        /* Populate Expert Information
           (Module 2B) */

        populateExpert();

        openAccordion(
            "accordionProfessional"
        );

        updateProgress(2);

        scrollToTop();

    }

    catch(error){

        console.error(error);

        showError(
            error.message ||
            "Unable to verify your email."
        );

    }

    finally{

        if(verifyButton){

            verifyButton.disabled = false;

            verifyButton.innerHTML =
                "Verify & Continue";

        }

    }

}
/* ======================================================
   MODULE 2A.2
   FETCH EXPERT
====================================================== */

async function fetchExpert(email){

    const url =
        WEB_APP_URL +
        "?action=getExpert" +
        "&emailAddress=" +
        encodeURIComponent(email);

    const response =
        await fetch(url);

    if(!response.ok){

        throw new Error(
            "Unable to connect to Diafemme server."
        );

    }

    const result =
        await response.json();

    if(!result.success){

        throw new Error(
            result.message ||
            "Verification failed."
        );

    }

    ExpertOnboarding.expert =
        result.data;

    return result;

}
/* ======================================================
   MODULE 2B
   SMART DATA BINDING
====================================================== */

function populateExpert(){

    if(!ExpertOnboarding.expert){

        showError("Expert information could not be loaded.");

        return;

    }

    const expert = ExpertOnboarding.expert;

    /* ---------------------------------------------
       PROFESSIONAL INFORMATION
    ---------------------------------------------- */

    setDisplay(
        "applicationIdDisplay",
        expert.applicationId
    );

    setDisplay(
        "applicationIdReference",
        expert.applicationId
    );

    setDisplay(
        "consultationTierDisplay",
        expert.consultationTier
    );

    setDisplay(
        "fullNameDisplay",
        expert.fullName
    );

    setDisplay(
        "professionalTitleDisplay",
        expert.professionalTitle
    );

    setDisplay(
        "qualificationsDisplay",
        expert.qualifications
    );

    setDisplay(
        "primarySpecialityDisplay",
        expert.primarySpeciality
    );

    setDisplay(
        "expertCategoryDisplay",
        expert.expertCategory
    );

    setDisplay(
        "languagesDisplay",
        expert.languages
    );

    setDisplay(
        "expertiseDisplay",
        expert.areasOfExpertise
    );

    setDisplay(
        "healthConcernsDisplay",
        expert.healthConcernsSupported
    );

    setDisplay(
        "currentPracticeDisplay",
        expert.currentPractice
    );

    /* ---------------------------------------------
       PUBLIC PROFILE
    ---------------------------------------------- */

    setDisplay(
        "photoApplicationId",
        expert.applicationId
    );

    /* ---------------------------------------------
       PAYMENT
    ---------------------------------------------- */

    setDisplay(
        "paymentApplicationId",
        expert.applicationId
    );

    setDisplay(
        "feeConsultationTier",
        expert.consultationTier
    );

    /* ---------------------------------------------
       SUCCESS SCREEN
    ---------------------------------------------- */

    setDisplay(
        "successApplicationId",
        expert.applicationId
    );

    /* ---------------------------------------------
       STORE FOR FUTURE MODULES
    ---------------------------------------------- */

    ExpertOnboarding.onboarding = {

        applicationId:
            expert.applicationId,

        consultationTier:
            expert.consultationTier,

        consultationMode:
            expert.consultationMode,

        preferredContactMethod:
            expert.preferredContactMethod,

        morningAvailability:
            expert.morningAvailability,

        afternoonAvailability:
            expert.afternoonAvailability,

        eveningAvailability:
            expert.eveningAvailability

    };
    

    /* Prepare consultation schedule */

      loadConsultationSchedule();

      populateFeeInformation();

       }
/* ======================================================
   MODULE 5A
   POPULATE FEE INFORMATION
====================================================== */

function populateFeeInformation(){

    if(!ExpertOnboarding.expert){

        return;

    }

    const expert =
        ExpertOnboarding.expert;

    setDisplay(
        "feeConsultationTier",
        expert.consultationTier
    );

    setDisplay(
        "consultationFeeDisplay",
        "₹" + expert.consultationFee
    );

    setDisplay(
        "platformFeeDisplay",
        "₹" + expert.platformFee
    );

    setDisplay(
        "professionalFeeDisplay",
        "₹" + expert.professionalFee
    );

    setDisplay(
        "paymentApplicationId",
        expert.applicationId
    );

    console.log(
        "Consultation Fee Information Loaded"
    );

}
/* ======================================================
   MODULE 5C
   CONTINUE TO DECLARATION
====================================================== */

function continueFee(){

    clearMessage();

    openAccordion(
    "accordionPreferences"
);

    updateProgress(6);

    scrollToTop();

}
/* ======================================================
   MODULE 2C
   UI FLOW
====================================================== */

function verificationSuccessful(){

    /* Store verification status */

    ExpertOnboarding.verified = true;

    /* Open next accordion */

    openAccordion("accordionProfessional");

    /* Progress */

    updateProgress(2);

    /* Success message */

    showSuccess(
        "✔ Expert verified successfully. Please review your professional information before continuing."
    );

    /* Scroll */

    scrollToTop();

}

function verificationFailed(message){

    ExpertOnboarding.verified = false;

    showError(
        message ||
        "Unable to verify your expert application."
    );

}
/* ======================================================
   MODULE 3
   PUBLIC EXPERT PROFILE
====================================================== */

/* ======================================================
   MODULE 3
   PUBLIC EXPERT PROFILE
====================================================== */

function continueProfile(){

    clearMessage();

    const shortBio =
        document.getElementById("shortBio").value.trim();

    if(shortBio===""){

        showError(
            "Please write a short professional bio."
        );

        document.getElementById("shortBio").focus();

        return;

    }

    ExpertOnboarding.onboarding.shortBio =
        shortBio;

    
    openAccordion("accordionSchedule");

    updateProgress(4);

    scrollToTop();

}


function buildSchedule(){

    console.log("Module 4");

}

function submitOnboarding(){

    console.log("Module 6");

}
/* ======================================================
   MODULE 4A
   PARSE CONSULTATION AVAILABILITY
====================================================== */

function parseAvailability(value){

    if(!value){

        return [];

    }

    return value
        .split(",")
        .map(day => day.trim())
        .filter(day => day !== "");

}

/* ======================================================
   LOAD EXPERT CONSULTATION DAYS
====================================================== */

function loadConsultationSchedule(){

    if(!ExpertOnboarding.onboarding){

        showError(
            "Consultation schedule could not be loaded."
        );

        return;

    }

    const morningDays =
        parseAvailability(
            ExpertOnboarding.onboarding.morningAvailability
        );

    const afternoonDays =
        parseAvailability(
            ExpertOnboarding.onboarding.afternoonAvailability
        );

    const eveningDays =
        parseAvailability(
            ExpertOnboarding.onboarding.eveningAvailability
        );

    console.log("Morning Days", morningDays);

    console.log("Afternoon Days", afternoonDays);

    console.log("Evening Days", eveningDays);

    buildAvailabilitySection(
        "morningScheduleContainer",
        morningDays,
        "Morning"
    );

    buildAvailabilitySection(
        "afternoonScheduleContainer",
        afternoonDays,
        "Afternoon"
    );

    buildAvailabilitySection(
        "eveningScheduleContainer",
        eveningDays,
        "Evening"
    );

}
/* ======================================================
   MODULE 4B
   BUILD CONSULTATION AVAILABILITY
====================================================== */

function buildAvailabilitySection(containerId, days, period){

    const container =
        document.getElementById(containerId);

    if(!container){

        return;

    }

    container.innerHTML = "";

    if(days.length===0){

        container.innerHTML =
            "<p>No " +
            period.toLowerCase() +
            " consultation days available.</p>";

        return;

    }

    days.forEach(day=>{

        container.appendChild(

            createAvailabilityRow(day,period)

        );

    });

}
/* ======================================================
   CREATE ONE AVAILABILITY ROW
====================================================== */

function createAvailabilityRow(day,period){

    const row =
        document.createElement("div");

    row.className = "df-availability-row";

    row.innerHTML = `

        <div class="df-day-label">

            ${day}

        </div>

        <div class="df-time-group">

            <label>

                Available From

            </label>

            <select
                class="df-time-select"
                data-period="${period}"
                data-day="${day}"
                data-type="availableFrom">

                ${buildTimeOptions(period)}

            </select>

        </div>

        <div class="df-time-group">

            <label>

                Available Until

            </label>

            <select
                class="df-time-select"
                data-period="${period}"
                data-day="${day}"
                data-type="availableUntil">

               ${buildTimeOptions(period)}

            </select>

        </div>

    `;

    return row;

}
/* ======================================================
   TIME OPTIONS
====================================================== */

function buildTimeOptions(period) {
    const ranges = {
        Morning:  { start: 9, end: 12 },
        Afternoon:{ start: 12, end: 17 },
        Evening:  { start: 17, end: 20 }
    };

    const range = ranges[period];
    let html = '<option value="">Select</option>';

    for (let hour = range.start; hour <= range.end; hour++) {
        for (let minute = 0; minute < 60; minute += 30) {

            // Don't go past the end hour
            if (hour === range.end && minute > 0) {
                break;
            }

            const h = String(hour).padStart(2, "0");
            const m = String(minute).padStart(2, "0");

            html += `<option value="${h}:${m}">${h}:${m}</option>`;
        }
    }

    return html;
}
/* ======================================================
   MODULE 4C
   SAVE CONSULTATION AVAILABILITY
====================================================== */

function validateSchedule(){

    const rows =
        document.querySelectorAll(".df-availability-row");

    if(rows.length===0){

        showError(
            "No consultation availability has been configured."
        );

        return false;

    }

    let hasValidSlot = false;

    for(const row of rows){

        const from =
            row.querySelector(
                '[data-type="availableFrom"]'
            ).value;

        const to =
            row.querySelector(
                '[data-type="availableUntil"]'
            ).value;

        /* Ignore completely empty row */

       if(from === "" && to === ""){

    continue;

}

/* One field filled */

if(from === "" || to === ""){

    showError(
        "Please select both Available From and Available Until times."
    );

    return false;

}

/* End must be after Start */

if(from >= to){

    showError(
        "Available Until must be later than Available From."
    );

    return false;

}
        hasValidSlot = true;

    }

    if(!hasValidSlot){

        showError(
            "Please define at least one consultation availability."
        );

        return false;

    }

    return true;

}
/* ======================================================
   MODULE 4D
   SAVE CONSULTATION AVAILABILITY
====================================================== */

function continueSchedule(){

    /* Validate first */

    if(!validateSchedule()){

        return;

    }

    const rows =
        document.querySelectorAll(".df-availability-row");

    const schedule = [];

    rows.forEach(row=>{

        const from =
            row.querySelector('[data-type="availableFrom"]').value;

        const to =
            row.querySelector('[data-type="availableUntil"]').value;

        /* Skip empty rows */

        if(from === "" && to === ""){

        return;

          }

        schedule.push({

            period:
                row.querySelector('[data-type="availableFrom"]').dataset.period,

            day:
                row.querySelector('[data-type="availableFrom"]').dataset.day,

            availableFrom:
                from,

            availableUntil:
                to

        });

    });

ExpertOnboarding.onboarding.schedule = schedule;

   /* Continue */

ExpertOnboarding.currentStep = 5;

openAccordion("accordionFee");

updateProgress(5);

scrollToTop();

}
/* =====================================================
   COMPLETE ONBOARDING
===================================================== */

async function completeOnboarding() {

    ExpertOnboarding.onboarding.shortBio =
        document.getElementById("shortBio").value.trim();

    const info =
        document.getElementById("agreeInformation").checked;

    const terms =
        document.getElementById("agreeTerms").checked;

    const publication =
        document.getElementById("agreePublication").checked;

    if (!info || !terms || !publication) {

        alert(
            "Please accept all declarations before submitting your onboarding."
        );

        return;

    }

    ExpertOnboarding.onboarding.agreementAccepted = true;

    const submitButton =
        document.getElementById("submitOnboarding");

    if (submitButton) {

        submitButton.disabled = true;

        submitButton.innerHTML =
            "Please wait... Saving your information";

        submitButton.style.opacity = "0.7";

        submitButton.style.cursor = "not-allowed";

    }

    try {

        const response = await fetch(WEB_APP_URL, {

            method: "POST",

            body: new URLSearchParams({

                action: "saveOnboarding",

                onboarding: JSON.stringify(
                    ExpertOnboarding.onboarding
                )

            })

        });

        const text = await response.text();

        const result = JSON.parse(text);

        if (result.success) {

            setTimeout(function () {

                window.location.href =
                    "https://www.diafemme.com/pages/join-expert-homepage-success?applicationId=" +
                    encodeURIComponent(
                        ExpertOnboarding.onboarding.applicationId
                    );

            }, 700);

        } else {

            if (submitButton) {

                submitButton.disabled = false;

                submitButton.innerHTML =
                    "Complete Onboarding";

                submitButton.style.opacity = "1";

                submitButton.style.cursor = "pointer";

            }

            alert(result.message || "Unable to submit onboarding.");

        }

    }

    catch (err) {

        console.error(err);

        if (submitButton) {

            submitButton.disabled = false;

            submitButton.innerHTML =
                "Complete Onboarding";

            submitButton.style.opacity = "1";

            submitButton.style.cursor = "pointer";

        }

        alert("Unable to connect to the server.");

    }

}